<template>
<transition name="top">
  <div class="fans">
    <Header>
      <div slot="center">团队粉丝</div>
    </Header>
    <div v-for="(item,index) in fansData" :key="index" class="fans-card">
      <div style="display:flex;">
        <img :src="item.headUrl">
        <div class="fans-info">
          <div class="nick-name">{{item.nickName}}</div>
          <div class="time">{{item.createTime | parseTime2}}</div>
        </div>
      </div>
      <div v-if="item.isRecord == 1" class="record"><img src="@/assets/个人中心/record.png"></div>
    </div>
    <div v-if="fansData.length === 0" class="tips">
      <img src="@/assets/个人中心/team.png" alt="">
      您还没有粉丝噢
    </div> 
  </div>
</transition>
</template>

<script>
import {getUserInviteList} from '@/api/ownCenter'
import Header from "@/components/Header/index";
export default {
  name:'Fans',
  components:{
    Header
  },
  data(){
    return{
      fansData:[
      ]
    }
  },
  created(){
    var form = new FormData();
    form.append("userId",this.$store.state.userId); 
    getUserInviteList(form).then(res=>{
      this.fansData = res.data
    })
  }
}
</script>

<style lang="less" scoped>
.top-enter-active{
  opacity: 1;
  transition: all .32s ease;  
}
.top-enter
 {
  transform: translateY(-10%);
}
.fans{
  .fans-card{
    width: 96vw;
    height: 6rem;
    margin-left: 2vw;
    margin-top: 2vw;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    
    img{
      width: 4rem;
      height: 4rem;
      margin: 0 1rem;
      border-radius: 50%;
    }
    .fans-info{
      height: 4rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .nick-name{
        font-size: 1.6rem;
      }
      .time{
        font-size: 1.2rem;
        color: rgba(10, 10, 10, 0.6);
      }
    }
    .record{
      margin-right: 6px;
      img{
        width: 2rem;
        height: 2rem;
        opacity: .6;
      }

    }
  }
  .tips{
    font-size: 1.6rem;
    color: rgba(10, 10, 10, 0.7);
    width: 100vw;
    text-align: center;
    margin-top: 4rem ;
    img{
      opacity: .6;
      width: 2rem;
      height: 2rem;
      vertical-align: bottom;
    }
  }
}

</style>